import { render, staticRenderFns } from "./bookdy.vue?vue&type=template&id=17c84236&scoped=true"
import script from "./bookdy.vue?vue&type=script&lang=js"
export * from "./bookdy.vue?vue&type=script&lang=js"
import style0 from "./bookdy.vue?vue&type=style&index=0&id=17c84236&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c84236",
  null
  
)

export default component.exports